module.exports = __webpack_public_path__ + "static/media/0080.2e7305f6.jpg";